export default {
  'airticket': 'flight_takeoff',
  'group': 'group',
  'individual': 'flag',
  'accounting': 'account_circle',
  'excel': 'import_export',
  'management': 'settings',
  'sales': 'chat',
  'audit': 'monetization_on',
  'extension': 'extension',
  'search': 'search'
}



// WEBPACK FOOTER //
// ./src/constants/icon.js